class CustomStyle {
    static bgcolor = '#601C31';

    static cardBackGroundColor = '#222222';

    static sidedrawer = '#601c31';

    static activeTextcolor = '#dd3c3c';

    static activeTabColor = '#dd3c3c';

    static nonActiveTabColor = 'white';

    static nonActiveTextColor = '#FFF';

    static sidebarBackground = '#222222';

    static graphColor = '#FFF';

    static workspaceColor = '#222222';

    static lieceneCardColor = '#222222';

    static lieceneCardHeadColor = '#dd3c3c';

    static formLabelColor = 'black';

    static createButton = '#242B2E';

    static tableTextColor = '#fff';

    static summaryCard = '#5c0b251a';

    static cardBorderColor = '#601c31';

    static customZeeveStyle(): string {
      return `body{
        font-size: 14px;
        color: #171717;
    }
    .search-icon{
        margin-left: 5px;
        margin-top: 6px;
        color: #888a89;
        font-weight: 600;
        position:absolute;
    }
    .sideActiveLink{
        color: #3379DF;
        text-decoration: none;
        padding: .5rem 1rem;
        display: block;
        padding: 0.5rem 1rem;
        text-decoration: none;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;
    }
    .activeTabColor{
        color: #3379DF ;
    }
    .group { 
        display: table;
        width: 77%;
        font-size: 14px;
      }
      .item {
        display: table-cell;
      }
      .text { 
        white-space: nowrap;
        width: 1%;
        padding: 0 10px;
      }
      .line {
        border-bottom: 1px solid;
        position: relative;
        top: -.7rem;
      }
    .badge{
        background-color: #2a74f1;
        color: white;
        font-size: 12px;
        border-radius: 5px;
    }
    .nonActiveLink{
        text-decoration: none;
        color: black;
        padding: .5rem 1rem;
        display: block;
        text-decoration: none;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;
        
    }
    .nonActiveTabColor{
        color: #566573;
    }
    .activeTextColor{
        color: #3379DF ;
    }
    .nonActiveTextColor{
        color: #000;
    }
    .card-protocol{
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: 20px;
    }
    
    .search input{
        background: rgba(143, 146, 161, 0.05);
        border-radius: 12px;
        border: none;
    }
    .avatar-title{
        font-size: 12px;
        font-weight: 600;
    }
    .avatar-name{
        font-size: 9px;
        font-weight: 450;
    }
    .avatar-image{
        box-shadow: #0062ff 0px 0px 0px 2px;
    }
    .avatar-image:hover{
        box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
    }
    .workspace{
        background-color:  rgba(143, 146, 161,0.03);
        border-radius: 25px 0px 0px;
    }
    .span-color{
        color: #92929D;
    }
    .card{
        border: 1px solid #E2E2EA;
        border-radius: 16px;
    }
    .createButton{
        color: white;
        background-color: #4585E1;
    }
    .square{
        background-color:  rgba(161, 161, 161, 0.05);
        border: 0.4px solid rgba(161, 161, 161, 0.10);
        padding:3px 14px;
        border-radius: 8px 0px 0px 8px;
    }
    .square2{
        background-color:  rgba(161, 161, 161, 0.05);
        border: 0.4px solid rgba(161, 161, 161, 0.10);
        padding:3px 14px;
        border-radius: 0px 8px 8px 0px;
    }
    .a-tag a{
        text-decoration: none;
        color: #0A0A18;
        font-size: 14px;
    }
    .transparent{
        background:transparent;
    }
    .create{
        color:rgba(16, 16, 32, 0.8);
        font-size: 10px;
        font-weight:500;
    }
    .add-new{
        height: 80px;
        width: 80px;
        background-color: rgba(0, 98, 255,0.1);
        border-radius: 50%;
    }
    .add-new h1{
        font-size: 50px;
        font-weight: 400;
        color: #0062FF;
    }
    .add-workspace p{
        color: #B5B5BE;
    }
    .fontsize{
        font-size: 12px;
        color: #8C8D8E;
        font-weight: 100;
    }
    .slidercard{
        border: 1px solid #E2E2EA;
        border-radius: 20px;
        background-blend-mode: overlay;
    }
    .bg-card{
        box-shadow: 0px 5px 15px rgb(68 68 79 / 10%);
        border-radius: 8px;
    }
    .all-color{
        color: #171717;
    }
    .card-footer{
        border-radius: 0px 0px 24px 24px !important;
        background-color: #fff;
    }
    .modal-header{
        border-bottom: 0.4px solid rgba(161, 161, 161, 0.10);
    }
    .label-1{
        color: #8F92A1;
        font-weight: bold;
    }
    .node-process{
        background-color: #fff;
        height: auto;
        border-radius: 20px;
        border: 1px solid #E2E2EA;
    }
    .active-node{
        color: #171725 !important;
        font-weight: 500;
        border-bottom: blue !important;
    }
    .active-item{
        border-bottom: 1px solid #004DE5;
    }
    .node-font{
        font-size: 10px;
        color: rgba(23, 23, 23, 0.6);
    }
    .network-process{
        background-color: #fff;
        height: 650px;
        border-radius: 20px;
        border: 1px solid #E2E2EA;
    }
    .description{
        color: #0062FF;
        font-family: Poppins;
        font-weight: 500;
        font-size: 18px;
    }
    #floatingPassword{
        background: #FAFBFF;
    }
    .textdata{
        font-size: 12.7337px;
        line-height: 20px;
        color: rgba(16, 16, 32, 0.8);
    }
    .zeeve-license{
        background: #0062FF;
        border-radius: 16px;
    }
    .license{
        background-color: #fff;
        width: 100%;
        margin: auto;
        font-weight: 600;
        text-align: center;
        font-size: 16px;
        color: rgba(16, 16, 32, 0.8);
        border-radius: 12px;
        line-height: 2;
    }
    .license span{
        font-size: 12px !important;
        color: rgba(45, 45, 131, 0.7);
    }
    .cloud-spent{
        color: #fff;
    }
    .activelink{
        color: #0062FF;
    }
    .choose-border{
        border: 1px solid #E7E7ED;
        border-radius: 8px;
        width: 103%;
        margin-left: -17px;
    }
    .form-control:focus {
        box-shadow: none;
        border: 1px solid #6a8de6;
    }
    .cordaversion select{
        background-color: rgba(143, 146, 161, 0.05);
        border: 1px solid rgba(23, 23, 23, 0.1);
        border-radius: 16px;
        font-size: 14px;
    }
    .cordaversion input{
        background-color: rgba(143, 146, 161, 0.05);
        border: 1px solid rgba(23, 23, 23, 0.1);
        border-radius: 16px;
        font-size: 14px;
    }
    .cloud-select:hover{
        box-shadow: 0px 5px 15px rgb(68 68 79 / 10%);
        border-radius: 16px;
        width: 100px;
    }
    .cloud-details{
        background-color: rgba(0, 98, 255, 0.1);
        border: 1px solid #0062FF;
        border-radius: 32px;
    }
    .manage-sub{
        font-size: 12px;
        color: #a19e95;
    }
    .nav-tabs .nav-link.active {
        color: #0062FF;
    }
    .head-bg {
        background: #ebedf0;
    }
    .cloud-account{
        border: 1px solid #d7dbd8;
        border-radius: 16px;
    }
    .comingSoon{
        background-color: #3781ef;
        color: white;
    }
    .comingSoon:hover{
        color: white;
    }
    .img-boxshawdow img:hover{
        box-shadow: rgb(67 71 85 / 27%) 0px 0px 0.25em, rgb(90 125 188 / 5%) 0px 0.25em 1em;
        border-radius: 50%;
    }
    .workSpaceCard{
        background-color: white;
        border: 1px solid #E2E2EA;
        border-radius: 20px;
    }
    .addCloudBody{
        border: 2px solid #cdc9c9;
        border-radius: 20px;
        background-color: #b3afaf14;
    }
    .boldText{
        font-weight:450;
    }
    .activetext{
        color: #0062FF;
    }
    .offcanvas-backdrop.show{
        opacity: 0.2 !important;
    }
    .cards-susbscription {
        border: 1px solid #e2e2ea;
         border-radius: 10%;
         cursor: pointer;
         padding:10px;
         background-color: white;
        
       }
    .cards-susbscription :hover {
        border: 1px solid #e2e2ea;
        background-color: blue;
        
    }
    .card-susbscription {
        background: #ffffff;
        border-radius: 20px;
        cursor: pointer;
        position: relative;
        border: 1px solid #e2e2ea;
      }
      .card-susbscription:hover{
        background: #f2f6fc;
      }
      .cardpayment{
        background: #FFFFFF;
        border: 2px solid #e2e2ea;
        box-sizing: border-box;
        border-radius: 20px;
      }
      .card-susbscription .active {
        position: absolute;
        top: 1.5rem;
        font-weight: 700;
        color: white;
        text-transform: uppercase;
        padding: 0.5rem;
        background: #198754;
        border-radius: 0px 10px 10px 0px;
        font-size: 0.6rem;
      }
      .card-susbscription .selected {
        position: absolute;
        right: 1rem;
        top: .9rem;
      }
      .card-susbscription .header {
        font-size: 2rem;
        font-weight: 700;
      }
      .card-susbscription .sub-heading {
        font-size: 0.75rem;
        color: #6c757d !important;
        font-weight: 400
      }
      .card-susbscription .price {
        margin-top: 1.5rem;
        line-height: 90%;
        font-weight: 700;
        color: #6c757d !important;
      }
      .card-susbscription .price .unit {
        font-size: 1rem;
        vertical-align: middle;
      }
      .card-susbscription .price .value {
        font-size: 3rem;
      }
      .card-susbscription .price .period {
        font-size: 0.7rem;
        vertical-align: middle;
      }

    .toggle i {
        color: #000;
    }`;
    }

    static customHeliosStyle(): string {
      return `body{
        font-size: 14px;
        color: #fff;
        background: ${this.bgcolor};
    }
    .search-icon{
        margin-left: 5px;
        margin-top: 6px;
        color: #888a89;
        font-weight: 600;
        position:absolute;
    }
    .search input{
        background: rgba(143, 146, 161, 0.05);
        border-radius: 12px;
        border: none;
    }
    .createButton{
        color: ${this.nonActiveTextColor};
        background-color: ${this.createButton};
    }
    .createButton:hover{
        color: ${this.activeTextcolor};
        background-color: ${this.createButton};
    }
    .card-protocol{
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: 20px;
    }
    .nav :hover{
        color: ${this.nonActiveTabColor};
    }
    
    .tableTextColor{
        color: ${this.tableTextColor};
    }
    .activeTabColor{
        color: ${this.activeTabColor};
    }
    .nonActiveTabColor{
        color: ${this.nonActiveTabColor};
    }
    .avatar-title{
        font-size: 12px;
        font-weight: 600;
    }
    .addCloudBody{
        border: 2px solid #cdc9c9;
        border-radius: 20px;
        background-color: #222222;
    }
    .addCloudField{
        border-color: white;
        color:white;
    }
    .avatar-name{
        font-size: 9px;
    }
    .avatar-image{
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
    .avatar-image:hover{
        box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
    }
    .workspace{
        background: linear-gradient( 
            0deg, rgba(34, 34, 34, 0.25), rgba(34, 34, 34, 0.25) );
                background-blend-mode: overlay;
                border-radius: 25px 0px 0px 0px;
    }
    .span-color{
        color: #92929D;
    }
    .activeTextColor{
        color: ${this.activeTextcolor};
        font-size: '15px';
    }
    .nonActiveTextColor{
        color: ${this.nonActiveTextColor};
        font-size: '15px';

    }
    .boldText{
        font-weight:450;
    }
    .card{
        border-radius: 20px;
        background-blend-mode: overlay;
        background-color: ${this.cardBackGroundColor};

    }
    .badge{
        background-color: ${this.lieceneCardHeadColor};
        color: white;
        font-size: 12px;
        border-radius: 5px;
    }
    .comingSoon{
        background-color: ${this.lieceneCardHeadColor};
        color: white;
    }
    .comingSoon:hover{
        color: white;
    }
    .slidercard{
        border-radius: 20px;
        background-blend-mode: overlay;
        height: 305px;
    }
    .sideDrawer{
        background-color: ${this.sidedrawer};
        font-size: '15px';
    }
    .activetext{
        color: 'green';
    }
    .card-footer {
        background-color: #222222;
    }
    .square{
        background-color:  rgba(161, 161, 161, 0.03);
        border: 0.4px solid rgba(161, 161, 161, 0.10);
        padding:3px 14px;
        border-radius: 8px 0px 0px 8px;
    }
    .square2{
        background-color:  rgba(161, 161, 161, 0.03);
        border: 0.4px solid rgba(161, 161, 161, 0.10);
        padding:3px 14px;
        border-radius: 0px 8px 8px 0px;
    }
    .a-tag a{
        text-decoration: none;
        color: #fff;
        font-size: 14px;
    }
    .create{
        color:#fff;
        font-size: 10px;
    }
    .add-new{
        height: 80px;
        width: 80px;
        background-color: rgba(0, 98, 255,0.1);
        border-radius: 50%;
    }
    .add-new h1{
        font-size: 50px;
        font-weight: 400;
        color: #0062FF;
    }
    .add-workspace p{
        color: #B5B5BE;
    }
    .fontsize{
        font-size: 12px;
        color: #8C8D8E;
        font-weight: 100;
    }
    .bg-card{
        box-shadow: 0px 5px 15px rgb(68 68 79 / 10%);
        border-radius: 8px;
    }
    .all-color{
        color: #fff;
    }
    .modal-header{
        border-bottom: 0.4px solid rgba(161, 161, 161, 0.10);
    }
    .label-1{
        color: #8F92A1;
        font-weight: bold;
    }
    .node-process{
        background-color: #fff;
        height: auto;
        border-radius: 20px;
        border: 1px solid #E2E2EA;
    }
    .active-node{
        color: #171725 !important;
        font-weight: 500;
        border-bottom: blue !important;
    }
    .active-item{
        border-bottom: 1px solid #FFF;
    }
    .nav-link{
        color: '#fff';
    }
    .node-font{
        font-size: 10px;
        color: #fff;
    }
    .network-process{
        background-color: #fff;
        height: 650px;
        border-radius: 20px;
        border: 1px solid #E2E2EA;
    }
    .description{
        color: #FFF;
        font-family: Poppins;
        font-weight: 500;
        font-size: 18px;
    }
    #floatingPassword{
        background: #FAFBFF;
    }
    .textdata{
        font-size: 12.7337px;
        line-height: 20px;
        color: #fff;
    }
    .formTextColor{
        color: ${this.formLabelColor};
    }
    .myDetailField{
        background: transparent;
        border: 2px solid #fff;
        border-radius: 12px;
        padding: 3px;
    }
    .transparent{
        background:transparent;
    }
    .workSpaceCard{
        border: 2px solid ${this.cardBorderColor};
        border-radius: 25px;
        background-blend-mode: overlay;        
    }
    .cardBlack{
        background: ${this.cardBackGroundColor};
        background-blend-mode: overlay;
        border-radius: 25px;
        padding: 40px 40px;
        margin-top: 3%;
        margin-bottom: 3%;
       
    }
    .zeeve-license{
        background: ${this.lieceneCardColor};
        border-radius: 16px;
    }
    .license{
        background-color: ${this.lieceneCardHeadColor} ;
        width: 100%;
        margin: auto;
        font-weight: 600;
        text-align: center;
        font-size: 16px;
        color: #fff;
        border-radius: 12px;
        line-height: 2;
    }
    .license span{
        font-size: 12px !important;
        color: rgba(93, 40, 53, 0.7);
    }
    .cloud-spent{
        color: #fff;
    }
    .activelink{
        color: 'red';
    }
    .choose-border{
        border: 1px solid #E7E7ED;
        border-radius: 8px;
        width: 103%;
        margin-left: -17px;
    }
    .form-control:focus {
        box-shadow: none;
        color:#fff;
        background: transparent;
        border: 1px solid ${this.cardBorderColor};
    }
    .cordaversion select{
        background-color: rgba(143, 146, 161, 0.05);
        border: 1px solid rgba(23, 23, 23, 0.1);
        border-radius: 16px;
        font-size: 14px;
    }
    .cordaversion input{
        background: transparent;
        border: 1px solid white;
        border-radius: 16px;
        color:#fff
        font-size: 14px;
    }
    .form-control:disabled{
        box-shadow: none;
        color:#fff;
        background: transparent;
        border: 1px solid #FFF;

    }
    .cloud-select:hover{
        box-shadow: 0px 5px 15px rgb(68 68 79 / 10%);
        border-radius: 16px;
        width: 100px;
    }
    .cloud-details{
        background-color: ${this.summaryCard};
        border: 1px solid ${this.activeTextcolor};
        border-radius: 32px;
    }
    .manage-sub{
        font-size: 12px;
        color: #a19e95;
    }
    .nav-tabs .nav-link.active {
        color: #FFFFF;
    }
    .nonActiveLink{
        color: white;
        text-decoration: none;
        padding: .5rem 1rem;
        display: block;
        padding: 0.5rem 1rem;
        text-decoration: none;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;    
    }
    .sideActiveLink{
        color: ${this.activeTextcolor};
        background: ${this.sidebarBackground};
        text-decoration: none;
        padding: 0.5rem 1rem;
        background-blend-mode: overlay;
        border-radius: 5px;
        display: block;
        padding: 0.5rem 1rem;
        text-decoration: none;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;
    }
    .head-bg {
        background: #601c3140;
        color: white;
    }
    .textDanger{
        color: ${this.activeTextcolor};
    }
    .cloud-account{
        border: 1px solid #d7dbd8;
        border-radius: 16px;
    }
    .graphColor{
        color: '#FFF';
    }
    .formField{
        background: transparent;
        border: 2px solid #fff;
        border-radius: 12px;
        padding: 3px;
    }
    .img-boxshawdow img:hover{
        box-shadow: rgb(67 71 85 / 27%) 0px 0px 0.25em, rgb(90 125 188 / 5%) 0px 0.25em 1em;
        border-radius: 50%;
    }
    .offcanvas-backdrop.show{
        opacity: 0.2 !important;
    }
    .nav-link:focus, .nav-link:hover{
        color:#dd3c3c;
    }
    .heliousspace{
        margin-bottom: 0.9rem;
    }
    .toggle i {
        color: #d7dbd8;
    }`;
    }
}
export default CustomStyle;